/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
  GetApiV1CourseregistrationSharedStatusReasonListQueryParams,
  GetApiV1CourseregistrationSharedStatusReasonList401,
  GetApiV1CourseregistrationSharedStatusReasonList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedStatusReasonList.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationSharedStatusReasonList } from "../../clients/courseRegistrationSharedController/getApiV1CourseregistrationSharedStatusReasonList.ts";

export const getApiV1CourseregistrationSharedStatusReasonListQueryKey = (
  params?: GetApiV1CourseregistrationSharedStatusReasonListQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/shared/status-reason-list" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationSharedStatusReasonListQueryKey =
  ReturnType<typeof getApiV1CourseregistrationSharedStatusReasonListQueryKey>;

export function getApiV1CourseregistrationSharedStatusReasonListQueryOptions(
  params?: GetApiV1CourseregistrationSharedStatusReasonListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationSharedStatusReasonListQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedStatusReasonList401
      | GetApiV1CourseregistrationSharedStatusReasonList500
    >,
    GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationSharedStatusReasonList(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os motivos de status ativos filtrados pelo tipo de status de matrícula informado. Para status Cancelado ou CanceladoNaMatrícula retorna motivos do tipo Cancelamento; para status Rejeitado retorna motivos do tipo Rejeição; para os demais status retorna todos os motivos ativos. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de motivos de status para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/status-reason-list}
 */
export function useGetApiV1CourseregistrationSharedStatusReasonList<
  TData = GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
  TQueryData = GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationSharedStatusReasonListQueryKey,
>(
  params?: GetApiV1CourseregistrationSharedStatusReasonListQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationSharedStatusReasonListQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationSharedStatusReasonList401
          | GetApiV1CourseregistrationSharedStatusReasonList500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationSharedStatusReasonListQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationSharedStatusReasonListQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedStatusReasonList401
      | GetApiV1CourseregistrationSharedStatusReasonList500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
